(self.webpackChunkrstlWebpackJsonp =
  self.webpackChunkrstlWebpackJsonp || []).push([
  [145],
  {
    309: () => {
      !(function () {
        ((window.jdgmSettings = window.jdgmSettings || {}),
          (window.jdgmSettings = Object.assign(window.jdgmSettings, {
            widget_star_color: "rgba(var(--color-orange) / 1)",
          })));
        var e = function () {
          document
            .querySelectorAll('.jdgm-rev-widg__summary-stars[role="img"]')
            .forEach(function (e) {
              (e.querySelectorAll("a").forEach(function (e) {
                var t = document.createElement("span");
                ((t.className = e.className),
                  t.classList.remove("jdgm-link"),
                  (t.textContent = e.textContent),
                    e.replaceWith(t));
              }),
                e.querySelectorAll("button").forEach(function (e) {
                  var t = document.createElement("span");
                  ((t.className = e.className),
                    (t.textContent = e.textContent),
                  e.replaceWith(t));
                }));
            });

          /*
           * Judge.me's new widget keeps the rating controls inside its
           * collapsible filter panel. Open that panel once it is rendered so
           * the rating choices can replace the search / filter / sort tools.
           * The radios remain Judge.me's native controls, so selecting a
           * rating updates the review list without a parallel filter state.
           */
          document
            .querySelectorAll(
              '.section-addon-judgeme-product-reviews .addon-judgeme-review-widget'
            )
            .forEach(function (e) {
              var t = e.querySelector('.jm-custom-answer-filter');
              if (
                t &&
                !e.querySelector('.jm-filter-panel') &&
                'true' !== t.getAttribute('aria-expanded') &&
                !e.dataset.boringFilterRequested
              ) {
                e.dataset.boringFilterRequested = 'true';
                t.click();
              }

              var r = e.querySelector('.jm-filter-panel');
              var i = e.querySelector('.jm-review-widget-minimal-header');
              if (r && i && r.parentElement !== i) i.append(r);

              /* The product metafield is the same live Judge.me payload that
               * renders the widget. Its histogram keeps the filter counts in
               * sync with the product rather than with static design data. */
              var n =
                window.jdgm &&
                window.jdgm.data &&
                window.jdgm.data.reviewWidget &&
                window.jdgm.data.reviewWidget[e.dataset.id];
              var o = {};
              (n && n.histogram ? n.histogram : []).forEach(function (e) {
                o[e.rating] = e.frequency;
              });

              e.querySelectorAll('.jm-review-item').forEach(function (e, t) {
                var r = e.querySelector('.jm-star-rating');
                if (!r || r.dataset.boringRatingRendered) return;

                var i =
                  r.getAttribute('aria-label') ||
                  r.getAttribute('title') ||
                  r.textContent;
                var a = i.match(/([1-5])\s*(?:out of|\/)/i);
                var s = a
                  ? Number(a[1])
                  : n && n.reviews && n.reviews[t]
                    ? Number(n.reviews[t].rating)
                    : 0;
                if (!s) return;

                while (r.firstChild) r.removeChild(r.firstChild);
                for (var l = 1; l <= 5; l += 1) {
                  var c = document.createElement('span');
                  c.className =
                    'boring-review-star boring-review-star--' +
                    (l <= s ? 'filled' : 'outline');
                  c.setAttribute('aria-hidden', 'true');
                  c.textContent = l <= s ? '★' : '☆';
                  r.append(c);
                }
                r.dataset.boringRatingRendered = 'true';
              });

              e.querySelectorAll('.jm-rating-filter__tag input').forEach(function (e) {
                var t = e.parentElement;
                var r = Number(e.value);
                var i = t.querySelector('.jm-rating-filter__stars');
                var n = t.querySelector('.jm-rating-filter__count');

                if (!i) {
                  i = document.createElement('span');
                  i.className = 'jm-rating-filter__stars';
                  i.setAttribute('aria-hidden', 'true');
                  t.append(i);
                }

                if (!n) {
                  n = document.createElement('span');
                  n.className = 'jm-rating-filter__count';
                  n.setAttribute('aria-hidden', 'true');
                  t.append(n);
                }

                if (i.childElementCount !== 5) {
                  while (i.firstChild) i.removeChild(i.firstChild);
                  for (var a = 1; a <= 5; a += 1) {
                    var s = document.createElement('span');
                    s.className =
                      'jm-rating-filter__star jm-rating-filter__star--' +
                      (a <= r ? 'filled' : 'outline');
                    s.textContent = a <= r ? '★' : '☆';
                    i.append(s);
                  }
                }

                var l = String(
                  Object.prototype.hasOwnProperty.call(o, r) ? o[r] : '0'
                );
                if (n.textContent !== l) n.textContent = l;

                Array.prototype.slice.call(t.childNodes).forEach(function (r) {
                  if (r !== e && r !== i && r !== n) t.removeChild(r);
                });
              });
            });
        };
        ("loading" === document.readyState
          ? document.addEventListener("DOMContentLoaded", e)
          : e(),
          new MutationObserver(function (t) {
            t.forEach(function (t) {
              t.addedNodes.length && e();
            });
          }).observe(document.body, { childList: !0, subtree: !0 }));
      })();
    },
  },
  (e) => {
    var t;
    ((t = 309), e((e.s = t)));
  },
]);
